module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17819/js/img/valuePropModals/WhatsApp/ValueProp2.svg"